var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5528 12.7518L10.2208 9.28631C11.0775 8.26788 11.5469 6.98648 11.5469 5.65249C11.5469 2.53576 9.01117 0 5.89444 0C2.7777 0 0.241943 2.53576 0.241943 5.65249C0.241943 8.76923 2.7777 11.305 5.89444 11.305C7.0645 11.305 8.17952 10.9521 9.13282 10.2821L12.4902 13.7739C12.6305 13.9196 12.8192 14 13.0215 14C13.2129 14 13.3946 13.927 13.5324 13.7943C13.8254 13.5124 13.8347 13.045 13.5528 12.7518ZM5.89444 1.47456C8.1982 1.47456 10.0724 3.34873 10.0724 5.65249C10.0724 7.95625 8.1982 9.83043 5.89444 9.83043C3.59068 9.83043 1.71651 7.95625 1.71651 5.65249C1.71651 3.34873 3.59068 1.47456 5.89444 1.47456Z",
    fill: "#7A828A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.81bbc20b976d0b534354b3cef4741aad.svg";
export { ForwardRef as ReactComponent };